import { render, staticRenderFns } from "./CustomerCorporateMenuType.vue?vue&type=template&id=2df5b365&scoped=true"
import script from "./CustomerCorporateMenuType.vue?vue&type=script&lang=js"
export * from "./CustomerCorporateMenuType.vue?vue&type=script&lang=js"
import style0 from "./CustomerCorporateMenuType.vue?vue&type=style&index=0&id=2df5b365&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df5b365",
  null
  
)

export default component.exports